export enum DeliveryNoteStatusEnum {
  DRAFT = "DRAFT",
  CONFIRMED = "CONFIRMED",
}

export const getDeliveryNoteStatusLabel = (statusEnum: DeliveryNoteStatusEnum): string => {
  switch (statusEnum) {
    case DeliveryNoteStatusEnum.DRAFT:
      return "BORRADOR";
    case DeliveryNoteStatusEnum.CONFIRMED:
      return "CONFIRMADO";
  }
};

export const getDeliveryNotesStatusOptions = (): { label: string; value: string }[] =>
  Object.keys(DeliveryNoteStatusEnum).map((val) => {
    const value = DeliveryNoteStatusEnum[val as keyof typeof DeliveryNoteStatusEnum];
    return { label: getDeliveryNoteStatusLabel(value), value: value, translate: true };
  });
